import React, { useState, useRef, useEffect } from "react";
import NotificationPanels from "../NotificationPanels";
import ClientHeader from "../Partials/ClientHeader";
import ClientSideBar from "../Partials/ClientSideBar";
import Header from "../Header";
import Sidebar from "../Sidebar";
import CandidateTab from "../CandidateTab";
import StepCount from "../Common/StepCount";
import Footer from "../Footer";
import FormContainer from "./FormContainer";
import { useSelector } from "react-redux";
import ProgressHeading from "../Common/ProgressHeading";

const EmploymentContainer = () => {
  const form = useRef();
  const [role, setRole] = useState();
  const [employmentStatus, setEmploymentStatus] = useState("Select option");
  const [showTabs, setShowTabs] = useState(false); // State to control visibility of tabs

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  const handleDropdownChange = (event) => {
    const value = event.target.value;
    setEmploymentStatus(value);
    if (value !== "Select option") {
      setShowTabs(true); // Show tabs when a valid option is selected
    } else {
      setShowTabs(false); // Hide tabs if "Select status" is selected
    }
  };

  return (
    <>
      <NotificationPanels />
      {role === "EP" ? <ClientHeader /> : <Header />}
      {role === "EP" ? <ClientSideBar /> : <Sidebar />}
      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Employment"} />
            </div>
            <div className="col bg-gray-mbl">
              <form ref={form} className="p-3 form2 form-section">
                <StepCount activeTab={"Employment"} />
                <FormContainer />
              </form>
              <Footer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EmploymentContainer;
